export default __webpack_public_path__ + "b8159fafbaa7804f0a7ca121d448878d.png";